// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__IjzM4","title":"Images45_title__1H76R","images":"Images45_images__4Aws0"};